import { render, staticRenderFns } from "./OrdinanceTableModal.vue?vue&type=template&id=7d69d3e0&scoped=true&"
import script from "./OrdinanceTableModal.vue?vue&type=script&lang=ts&"
export * from "./OrdinanceTableModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrdinanceTableModal.vue?vue&type=style&index=0&id=7d69d3e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d69d3e0",
  null
  
)

export default component.exports